import { isInputError } from "astro:actions";
import type React from "react";

import { categories } from "~/utils/category";
import type { FragmentType } from "~/utils/fragment";

import { Checkbox } from "../Checkbox";
import { DialogTitle } from "../DialogTitle";
import { Select } from "../Select";
import { TextField } from "../TextField";
import { CollectionSelect } from "./CollectionSelect";
import { LanguagePicker } from "./LanguagePicker";
import type { PackForm_PackFragment } from "./PackForm_PackFragment";

export const PackForm: React.FC<
  React.PropsWithChildren<{
    error: Error | null;
    pack?: FragmentType<"Pack", { select: typeof PackForm_PackFragment }>;
  }>
> = ({ pack, error, children }) => {
  return (
    <div className="space-y-4">
      <DialogTitle>Pack settings</DialogTitle>
      {children}
      <TextField
        label="Pack title"
        required
        name="name"
        placeholder="What is your pack about?"
        defaultValue={pack?.name}
        error={isInputError(error) ? error?.fields.name?.[0] : undefined}
      />
      <CollectionSelect
        error={error}
        defaultValue={pack?.collection?.id.toString()}
      />
      <Select
        label="Category"
        defaultValue={pack?.category ?? undefined}
        name="category"
      >
        <option value="">Select a category (optional)</option>
        {Object.entries(categories).map(([key, category]) => (
          <option key={key} value={key}>
            {category.emoji} {category.name}
          </option>
        ))}
      </Select>
      <LanguagePicker defaultValue={pack?.language} />
      <Checkbox defaultChecked={pack?.private} name="private">
        Hide this pack from public listings
      </Checkbox>
    </div>
  );
};
